/**
 * @file Fetch emojis
 */
import { fetchJson } from '@padlet/fetch'
import { EmojiVersion } from './enums'
import { emojiPngUrl, emojiSvgUrl, parseEmojiCategories } from './icons/emoji'
import { Emoji, EmojiCategory, EmojiCollectionsBundle } from './types'

const BLOCKED_EMOJI_CODES = [
  '1f346', // 🍆 eggplant
  '1f351', // 🍑 peach
  '1f445', // 👅 tongue
  '1f4a6', // 💦 sweat droplets
  '1f52a', // 🔪 kitchen knife
  '1fa78', // 🩸 drop of blood
  '1f4a3', // 💣 bomb
  '1f52b', // 🔫 pistol
  '1f4a9', // 💩 pile of poo
  '1f595', // 🖕 middle finger
]

interface EmojiManifest {
  codes: Record<string, string[]>
  details: Record<string, Emoji>
}

/**
 * Fetches emojis that we can use in our wall settings panel.
 * @param version [EmojiVersion] The version of emojis to fetch.
 * @returns Promise that resolves to an object with labels that map to a collection of emojis.
 */
async function fetchEmojis(
  version: EmojiVersion = EmojiVersion.legacy,
  options: {
    /** The file format of the emoji. @default 'png' */
    format?: 'svg' | 'png'
  } = {},
): Promise<EmojiCollectionsBundle> {
  const result: EmojiCollectionsBundle = {}
  const emojiManifestUrl =
    version == EmojiVersion.legacy
      ? 'https://padlet.net/icons/emoji_manifest.json'
      : `https://padlet.net/icons/${version}/emoji_manifest.json`
  const { codes: emojiCodes, details: emojiDetails } = await fetchJson<EmojiManifest>(emojiManifestUrl, {
    cors: true,
  })
  const categories = parseEmojiCategories(Object.keys(emojiCodes))
  const typedEmojiCodes = emojiCodes
  categories.forEach((ec: EmojiCategory): void => {
    const emojis = typedEmojiCodes[ec.label]
      .filter((code: string): boolean => !BLOCKED_EMOJI_CODES.includes(code))
      .map((code: string): Emoji => {
        const {
          name,
          // shortname,
          keywords,
        } = emojiDetails[code]
        return {
          code,
          name, // TODO: include translations
          // shortname,
          keywords,
          url: options?.format === 'svg' ? emojiSvgUrl(code, version) : emojiPngUrl(code, version),
          // category: ec,
        }
      })
    result[ec.label] = {
      category: ec,
      emojis,
    }
  })
  return result
}

export default fetchEmojis
